import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";
import MessageParameters from "messaging/_api/queries/message-parameters";

export default class MessageQuery {
  public readonly messageParameters: MessageParameters;
  public readonly paginationParameters: PaginationParameters;

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([...this.paginationParameters.searchParams, ...this.messageParameters.searchParams]);
  }

  constructor(messageParameters: MessageParameters, paginationParameters: PaginationParameters) {
    this.paginationParameters = paginationParameters;
    this.messageParameters = messageParameters;
  }

  public isEqualTo(other: MessageQuery): boolean {
    if (!other) return false;
    return (
      this.messageParameters.isEqualTo(other.messageParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters)
    );
  }
}
